import React from "react";
import { Notification, NotificationTypes } from "../../models/NewExistingOwner";

interface IProps {
  data: Notification;
  onHide: Function;
  position: number;
}
interface IState {
  isVisible: boolean;
}

class Notify extends React.Component<IProps, IState> {
  state: IState = {
    isVisible: false
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isVisible: true }, this.wait);
    }, 10);
  }

  wait() {
    setTimeout(() => {
      this.setState({ isVisible: false }, this.remove);
    }, 1500);
  }

  remove() {
    setTimeout(() => {
      this.props.onHide();
    }, 150);
  }

  render() {
    const type = this.props.data.type || NotificationTypes.Success;

    return (
      <div
        className={`neo__notify neo__notify--${type.toLowerCase()} neo__notify--${this.state.isVisible ? "show" : ""}`}
        style={{ top: 90 + 55 * this.props.position }}
        onClick={() => this.setState({ isVisible: false }, this.remove)}
      >
        {this.props.data.text}
      </div>
    );
  }
}

export default Notify;
